import React, { useReducer } from 'react';

const initialState = {
    referenceElement: null,
    toggle: () => { },
    isOpen: false,
    toggleType: '',
};
const DropdownContext = React.createContext(initialState);
const DropdownProvider = ({ children, value }) => {
    const [state, dispatch] = useReducer((state = initialState, action) => {
        switch (action.type) {
            case 'SET_REFERENCE':
                return Object.assign(Object.assign({}, state), { referenceElement: action.payload });
            default:
                return state;
        }
    }, initialState);
    return (React.createElement(DropdownContext.Provider, { value: { state: Object.assign(Object.assign({}, state), value), dispatch } }, children));
};

export { DropdownContext, DropdownProvider };
